import React from "react";
import { MetricCard } from "../shared";
import {
  RAPID_TOTAL_REVENUE_LOADING_METRIC,
  type ServicesRapidRevenueMetric,
} from "./servicesRapidMappers";

interface ServicesRapidTotalRevenueCardProps {
  metric?: ServicesRapidRevenueMetric;
  /** Metric shown while loading; defaults to the Earned placeholder. */
  loadingMetric?: ServicesRapidRevenueMetric;
  isLoading?: boolean;
}

export const ServicesRapidTotalRevenueCard: React.FC<
  ServicesRapidTotalRevenueCardProps
> = ({
  metric = RAPID_TOTAL_REVENUE_LOADING_METRIC,
  loadingMetric = RAPID_TOTAL_REVENUE_LOADING_METRIC,
  isLoading = false,
}) => {
  const displayMetric = isLoading ? loadingMetric : metric;

  return (
    <MetricCard
      title={displayMetric.title}
      value={displayMetric.value}
      delta={displayMetric.delta}
      description={displayMetric.description}
      trend={displayMetric.trend}
      icon={displayMetric.icon}
      iconColor={displayMetric.iconColor}
      width="fill"
      className="max-w-[360px]"
    />
  );
};
